import React from 'react';
import styled from 'styled-components';
import DirectSellingHero from './DirectSellingHero';
import DirectSellingFeatures from './DirectSellingFeatures';

function DirectSellingPage() {
  return (
    <DirectSellingPageContainer>
      <DirectSellingHero />
      <DirectSellingFeatures />
    </DirectSellingPageContainer>
  );
}

const DirectSellingPageContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  background-color: #f8f9fa;
`;

export default DirectSellingPage; 